import { isValidQuery } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const HomeDepotSearchContent: SDEContent = {
  projectType: 'async_homedepot_search',
  projectCategory: 'homedepot',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/homedepot/search/v1`;
  },
  docsSection: 'homedepot-search-api',
  docsSectionTitle: 'Home Depot Search API',
  docsSectionAsync: 'homedepot-search-api-async',
  docsSectionAsyncTitle: 'Home Depot Search API (Async)',
  inputKey: 'search_term',
  inputsKey: 'search_terms',
  validatorFunction: isValidQuery,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Search terms',
      listLiteralInputPlaceholder: 'Enter one search term per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: "Input search term",
      inputSectionDescription: "Enter search terms in the input field or upload a CSV with your search terms to begin scraping Home Depot.",
    },
    projectContent: {
      title: 'Home Depot search',
      description: 'Extract well-structured product data from a keyword search on Home Depot like title, price, rating, model number and URLs.',
      icon: 'homedepot',
      inputTitle: 'Search term',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input search term',
      inputSectionDescription: 'Enter Home Depot search terms to begin scraping Home Depot.',
    },
    projectContent: {
      title: 'Home Depot search',
      description: 'Extract well-structured product data from a keyword search on Home Depot.',
      icon: 'homedepot',
    },
    enterInputsPlaceholder: 'lawn mower',
    enterInputsMessage: 'Enter keyword for scraping',
    codeViewPlaceHolder: 'Please provide a valid search term',
    dropdownTitle: 'Home Depot Search'
  }
};
